module.exports = {
    // Change this value for switch project – activeProject = foldername in @projects
    activeProject: 'indisigno'
}
